// HACK: Phase4Step2-2終了間際にESLintのルールが変更になり、ロジックは変更出来なかったため回避。
/* eslint-disable max-lines */
/********************************/
/*          About vuex          */
/********************************/
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapState, mapActions } from "vuex";
import apiService from '../../../../../share/util/api/service';
import error from '../../../../../common/nodejs/errors';
import { REQUEST_STATUS_COMPLETED, REQUEST_STATUS_FAILED } from '../../../../../share/util/api/polling';
import session from '../../../../../share/session';
import individualDiagnose from '../../../../../share/util/individualDiagnose';
import individualWorkSupportUtil from '../../../../../share/util/individualWorkSupportUtil';
import cstmTable from "../../../../../share/components/vue/PaginationTable";

/** マスタデータファイル拡張子 */
const MASTER_DATA_EXTENSION = 'cmf';

/** 各フェーズ定義 */
const PHASE = {
  INPUT_FILE: 'inputFile',
  INPUT_FILE_ERROR: 'inputFileError',
  IN_PROGRESS: 'inProgress',
  SUCCESS: 'success',
  ERROR_FINISH: 'errorFinish',
  RESULT_ERROR: 'resultError',
  FINISH_PROCESS_ERROR: 'finishProcessError',
  COMMUNICATION_ERROR: 'communicationError',
  ERROR: 'error',
};

/** API type定義 */
const API_TYPE = {
  UPLOAD: 'upload',
  CHECK: 'check',
  START: 'start',
  WRITE: 'write',
  FLOW: 'flow',
  STOP: 'stop',
  READ: 'read',
  ERROR_READ: 'errorRead',
  TERMINATE: 'terminate',
};

/** flow種別 */
const FLOW_TYPE = {
  SELF_CHECK: 'selfCheck',
  ESTIMATE: 'estimate',
  CREATE: 'create',
};

/** 保存ファイル名 */
const DefaultSaveFileName = 'output.txt';

export default {
  name: 'requirementSpMVS1',
  data() {
    return {
      phase: PHASE.INPUT_FILE,
      nextPhase: '',
      isLoading: false,
      isSessionChanged: false,
      extension: MASTER_DATA_EXTENSION,
      s3FilePath: '',
      resultValue: {
        front: null,
        left: null,
        right: null,
        rear: null,
        errorCause: null,
      },
      errorMessage: '',
      // テーブル関連
      columns: [],
      items: [],
      modal_special_requirement_MVS1: false
    };
  },
  components: {
    'cstm-table': cstmTable
  },

  props: {
    workSupportId: { type: Number, default: '', required: true }
  },

  computed: {
    ...mapState({
      netAppId: state => state.netAppConnector.pairingAppId
    }),
    ...mapState({
      isToLocked: state => state.app.isTimeoutLocked,
    }),

    /**
     * ダイアログのヘッダー色
     */
    headerColor() {
      switch (this.phase) {
        case PHASE.INPUT_FILE_ERROR:
        case PHASE.ERROR_FINISH:
        case PHASE.RESULT_ERROR:
        case PHASE.FINISH_PROCESS_ERROR:
        case PHASE.COMMUNICATION_ERROR:
        case PHASE.ERROR:
          return 'danger';
        case PHASE.SUCCESS:
          return 'success';
        case PHASE.INPUT_FILE:
        case PHASE.IN_PROGRESS:
        default:
          return 'secondary';
      }
    },

    systemTableColumns() {
      this.columns = [
        {
          name: 'itemName',
          label: `individual.label_table_item`,
          useResource: false,
        },
        {
          name: 'itemValue',
          label: `individual.label_table_header_calibration_result`,
          useResource: false,
        }
      ];
      return this.columns;
    },
  },

  methods: {
    ...mapActions('auth', ['logout', 'resetSession']),
    ...mapActions('app', ['setIsTimeoutLocked']),

    /** 初期化処理 */
    init() {
      this.modal_special_requirement_MVS1 = true;
    },

    /** Wizardを閉じる */
    async closeWizard() {
      this.$emit('close-wizard');
      this.modal_special_requirement_MVS1 = false;
    },

    /** その他エラー発生時の表示 */
    showUnexpectedError() {
      // 異常終了：エラー表示
      this.phase = PHASE.ERROR;
    },

    /**
     * API 通信で共通バリデーションでエラーが発生した際のコールバック
     * @param {object} result バリデーション結果
     */
    validateErrorResult(result) {
      individualDiagnose.apiErrorDefaultAction(
        this,
        result,
        // ログアウト処理のコールバック
        (self) => { self; this.logout(this); },
        // セッションリセット処理のコールバック
        (self) => { self; this.resetSession(this); },
        // その他エラー発生のコールバック
        (result) => { result; this.showUnexpectedError(); },
      );
    },

    /** キャリブレーション実行処理 */
    async execute(file) {
      let ret = await this.doUpload(file);
      if (ret) {
        ret = await this.doCheck();
        if (ret) {
          // 以降はセッション遷移あり
          this.isSessionChanged = true;
          this.phase = PHASE.IN_PROGRESS;
          ret = await this.doStart();
          if (ret) {
            ret = await this.doWrite();
            if (ret) {
              ret = await this.flowProcess();
              // HACK: Phase4Step2-2終了間際にESLintのルールが変更になり、ロジックは変更出来なかったため回避。
              /* eslint-disable max-depth */
              if (ret) {
                ret = await this.doStop();
                if (ret) {
                  await this.successProcess();
                }
              }
            }
          }
        }
      }

      // 異常終了処理実行
      if (this.nextPhase === PHASE.ERROR_FINISH) {
        this.nextPhase = '';
        await this.errorProcess();
      }
    },

    /** ファイルアップロード処理 */
    async doUpload(file) {
      try {
        this.isLoading = true;

        // API実行パラメータ作成
        const systemId = individualDiagnose.getCurrentSystemId(this);
        const token = session.getToken();
        const requestBody = {
          id_token: token.id_token,
          type: API_TYPE.UPLOAD,
          fileName: file.name,
          is_special: true,
        };

        // API実行
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          systemId,
          this.workSupportId,
          requestBody,
          // エラー発生のコールバック
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          switch (response.data.status) {
            case REQUEST_STATUS_COMPLETED:
              // 正常終了
              this.s3FilePath = response.data.user_data.filePath;

              // ファイルアップロード
              try {
                // アップロード中に操作タイムアウトを発生させない
                this.setIsTimeoutLocked(true);
                // PUT（PreSignedURLを利用したS3へのファイルアップロード）を呼び出す
                await apiService.uploadFileToS3(response.data.user_data.uploadUrl, file);
                return true;
              } catch (e) {
                this.phase = PHASE.COMMUNICATION_ERROR;
              }
              break;
            case REQUEST_STATUS_FAILED:
              this.phase = PHASE.COMMUNICATION_ERROR;
              break;
            default:
              this.showUnexpectedError();
              break;
          }
        }
        return false;
      } finally {
        this.setIsTimeoutLocked(false);
        this.isLoading = false;
      }
    },

    /** マスタデータチェック処理 */
    async doCheck() {
      try {
        this.isLoading = true;

        // API実行パラメータ作成
        const systemId = individualDiagnose.getCurrentSystemId(this);
        const token = session.getToken();
        const requestBody = {
          id_token: token.id_token,
          type: API_TYPE.CHECK,
          filePath: this.s3FilePath,
          is_special: true,
        };

        // API実行
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          systemId,
          this.workSupportId,
          requestBody,
          // エラー発生のコールバック
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          switch (response.data.status) {
            case REQUEST_STATUS_COMPLETED:
              // 正常終了
              return true;
            case REQUEST_STATUS_FAILED:
              this.phase = PHASE.INPUT_FILE_ERROR;
              break;
            default:
              this.showUnexpectedError();
              break;
          }
        }
        return false;
      } finally {
        this.isLoading = false;
      }
    },

    /** 開始処理 */
    async doStart() {
      try {
        this.isLoading = true;

        // API実行パラメータ作成
        const systemId = individualDiagnose.getCurrentSystemId(this);
        const token = session.getToken();
        const requestBody = {
          id_token: token.id_token,
          type: API_TYPE.START,
          is_special: true,
        };

        // API実行
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          systemId,
          this.workSupportId,
          requestBody,
          // エラー発生のコールバック
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          switch (response.data.status) {
            case REQUEST_STATUS_COMPLETED:
              // 正常終了
              return true;
            case REQUEST_STATUS_FAILED:
              switch (response.data.async_code) {
                case error.WSP_073_COMMUNICATION_ERROR:
                  this.phase = PHASE.COMMUNICATION_ERROR;
                  break;
                case error.WSP_073_ERROR_FINISH:
                  // 異常終了処理遷移用
                  this.errorMessage = 'individual.label_error_start_calibration';
                  this.nextPhase = PHASE.ERROR_FINISH;
                  break;
                default:
                  this.showUnexpectedError();
                  break;
              }
              break;
            default:
              this.showUnexpectedError();
              break;
          }
        }
        return false;
      } finally {
        this.isLoading = false;
      }
    },

    /** 書込み処理 */
    async doWrite() {
      try {
        this.isLoading = true;

        // API実行パラメータ作成
        const systemId = individualDiagnose.getCurrentSystemId(this);
        const token = session.getToken();
        const requestBody = {
          id_token: token.id_token,
          type: API_TYPE.WRITE,
          filePath: this.s3FilePath,
          is_special: true,
        };

        // API実行
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          systemId,
          this.workSupportId,
          requestBody,
          // エラー発生のコールバック
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          switch (response.data.status) {
            case REQUEST_STATUS_COMPLETED:
              // 正常終了
              return true;
            case REQUEST_STATUS_FAILED:
              // 異常終了処理遷移用
              this.errorMessage = 'individual.label_error_write_master';
              this.nextPhase = PHASE.ERROR_FINISH;
              break;
            default:
              this.showUnexpectedError();
              break;
          }
        }
        return false;
      } finally {
        this.isLoading = false;
      }
    },

    /** フロー関連処理 */
    async flowProcess() {
      let ret = await this.doFlow(FLOW_TYPE.SELF_CHECK);
      if (ret) {
        ret = await this.doFlow(FLOW_TYPE.ESTIMATE);
        if (ret) {
          ret = await this.doFlow(FLOW_TYPE.CREATE);
          if (!ret) {
            this.errorMessage = 'individual.label_error_generate_map';
          }
          return ret;
        } else {
          this.errorMessage = 'individual.label_error_detected';
        }
      } else {
        this.errorMessage = 'individual.label_error_self_data_check';
      }
      return false;
    },

    /** フロー処理 */
    async doFlow(flowType) {
      try {
        this.isLoading = true;

        // API実行パラメータ作成
        const systemId = individualDiagnose.getCurrentSystemId(this);
        const token = session.getToken();
        const requestBody = {
          id_token: token.id_token,
          type: API_TYPE.FLOW,
          flowType: flowType,
          is_special: true,
        };

        // API実行
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          systemId,
          this.workSupportId,
          requestBody,
          // エラー発生のコールバック
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          switch (response.data.status) {
            case REQUEST_STATUS_COMPLETED:
              // 正常終了
              return true;
            case REQUEST_STATUS_FAILED:
              switch (response.data.async_code) {
                case error.WSP_073_COMMUNICATION_ERROR:
                  this.phase = PHASE.COMMUNICATION_ERROR;
                  break;
                case error.WSP_073_ERROR_FINISH:
                  // 異常終了処理遷移用
                  this.nextPhase = PHASE.ERROR_FINISH;
                  break;
                default:
                  this.showUnexpectedError();
                  break;
              }
              break;
            default:
              this.showUnexpectedError();
              break;
          }
        }
        return false;
      } finally {
        this.isLoading = false;
      }
    },

    /** 停止処理 */
    async doStop() {
      try {
        this.isLoading = true;

        // API実行パラメータ作成
        const systemId = individualDiagnose.getCurrentSystemId(this);
        const token = session.getToken();
        const requestBody = {
          id_token: token.id_token,
          type: API_TYPE.STOP,
          is_special: true,
        };

        // API実行
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          systemId,
          this.workSupportId,
          requestBody,
          // エラー発生のコールバック
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          switch (response.data.status) {
            case REQUEST_STATUS_COMPLETED:
              // 正常終了
              return true;
            case REQUEST_STATUS_FAILED:
              this.phase = PHASE.FINISH_PROCESS_ERROR;
              break;
            default:
              this.showUnexpectedError();
              break;
          }
        }
        return false;
      } finally {
        this.isLoading = false;
      }
    },

    /** 正常終了処理 */
    async successProcess() {
      const ret = await this.doRead();
      if (ret) {
        // 表示更新
        this.phase = PHASE.SUCCESS;
        this.$nextTick(() => {
          this.createTable();
        });
      }
    },

    /** 異常終了処理 */
    async errorProcess() {
      const ret = await this.doErrorRead();
      if (ret) {
        // 表示更新
        this.phase = PHASE.ERROR_FINISH;
        this.$nextTick(() => {
          this.createErrorTable();
        });
      }
    },

    /** 終了処理 */
    async doTerminate() {
      try {
        this.isLoading = true;

        // API実行パラメータ作成
        const systemId = individualDiagnose.getCurrentSystemId(this);
        const token = session.getToken();
        const requestBody = {
          id_token: token.id_token,
          type: API_TYPE.TERMINATE,
          is_special: true,
        };

        // API実行
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          systemId,
          this.workSupportId,
          requestBody,
          // エラー発生のコールバック
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          return true;
        }
        return false;
      } finally {
        this.isLoading = false;
      }
    },

    /** 読出し処理 */
    async doRead() {
      try {
        this.isLoading = true;

        // API実行パラメータ作成
        const systemId = individualDiagnose.getCurrentSystemId(this);
        const token = session.getToken();
        const requestBody = {
          id_token: token.id_token,
          type: API_TYPE.READ,
          is_special: true,
        };

        // API実行
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          systemId,
          this.workSupportId,
          requestBody,
          // エラー発生のコールバック
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          switch (response.data.status) {
            case REQUEST_STATUS_COMPLETED:
              // 正常終了
              this.resultValue.front = response.data.user_data.resultValue.front;
              this.resultValue.left = response.data.user_data.resultValue.left;
              this.resultValue.right = response.data.user_data.resultValue.right;
              this.resultValue.rear = response.data.user_data.resultValue.rear;
              return true;
            case REQUEST_STATUS_FAILED:
              this.phase = PHASE.RESULT_ERROR;
              break;
            default:
              this.showUnexpectedError();
              break;
          }
        }
        return false;
      } finally {
        this.isLoading = false;
      }
    },

    /** エラー用読出し処理 */
    async doErrorRead() {
      try {
        this.isLoading = true;

        // API実行パラメータ作成
        const systemId = individualDiagnose.getCurrentSystemId(this);
        const token = session.getToken();
        const requestBody = {
          id_token: token.id_token,
          type: API_TYPE.ERROR_READ,
          is_special: true,
        };

        // API実行
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          systemId,
          this.workSupportId,
          requestBody,
          // エラー発生のコールバック
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          switch (response.data.status) {
            case REQUEST_STATUS_COMPLETED:
              // 正常終了
              this.resultValue.front = response.data.user_data.resultValue.front;
              this.resultValue.left = response.data.user_data.resultValue.left;
              this.resultValue.right = response.data.user_data.resultValue.right;
              this.resultValue.rear = response.data.user_data.resultValue.rear;
              this.resultValue.errorCause = response.data.user_data.resultValue.errorCause;
              return true;
            case REQUEST_STATUS_FAILED:
              switch (response.data.async_code) {
                case error.WSP_073_COMMUNICATION_ERROR:
                  this.phase = PHASE.COMMUNICATION_ERROR;
                  break;
                case error.WSP_073_RESULT_ERROR:
                  this.phase = PHASE.RESULT_ERROR;
                  break;
                default:
                  this.showUnexpectedError();
                  break;
              }
              break;
            default:
              this.showUnexpectedError();
              break;
          }
        }
        return false;
      } finally {
        this.isLoading = false;
      }
    },

    /** テーブルデータ作成 */
    createTable() {
      this.items = [
        {
          itemID: 0,
          itemName: this.$t(`individual.row_target_front`),
          itemValue: this.getCalibrationResultText(this.resultValue.front),
        },
        {
          itemID: 1,
          itemName: this.$t(`individual.row_target_left`),
          itemValue: this.getCalibrationResultText(this.resultValue.left),
        },
        {
          itemID: 2,
          itemName: this.$t(`individual.row_target_right`),
          itemValue: this.getCalibrationResultText(this.resultValue.right),
        },
        {
          itemID: 3,
          itemName: this.$t(`individual.row_target_rear`),
          itemValue: this.getCalibrationResultText(this.resultValue.rear),
        }
      ];
    },

    /** エラー時のテーブルデータ作成 */
    createErrorTable() {
      this.createTable();
      this.items.push(
        {
          itemID: 4,
          itemName: this.$t(`individual.row_error_cause`),
          itemValue: `0x${this.resultValue.errorCause.toUpperCase()}`
        }
      );
    },

    /** ファイル入力ダイアログ表示 */
    async openFilePicker(extension) {
      try {
        // ファイル選択ダイアログを開く
        const options = {
          types: [
            {
              description: this.$t(
                `individual.open_picker_accept_description`
              ),
              accept: {
                'application/octet-stream': ['.' + extension]
              }
            }
          ],
          excludeAcceptAllOption: true,
          multiple: false
        };
        const fh_list = await window.showOpenFilePicker(options);
        const file = await fh_list[0].getFile();
        // 拡張子チェック
        if (!this.validation(file)) {
          this.phase = PHASE.INPUT_FILE_ERROR;
          return;
        }
        this.execute(file);
      } catch (e) {
        // ファイル選択がキャンセルされた場合等は、ダイアログを閉じる
        this.closeWizard();
        return;
      }
    },

    /** マスタデータチェック */
    validation: function (file) {
      // 拡張子チェック
      if (!file.name.endsWith('.' + this.extension)) {
        return false;
      }
      return true;
    },

    /** エラー要因保存 */
    async saveErrorCause() {
      let stream = null;
      try {
        // ファイル保存ダイアログを開く
        const options = {
          suggestedName: DefaultSaveFileName,
          types: [
            {
              description: this.$t(
                `individual.save_picker_accept_description`
              ),
              accept: {
                'text/plain': ['.txt']
              }
            }
          ],
          excludeAcceptAllOption: true,
          multiple: false
        };
        const fh = await window.showSaveFilePicker(options);

        // ファイル保存
        stream = await fh.createWritable();
        const blob = new Blob([this.resultValue.errorCause], {
          type: 'text/plain'
        });
        await stream.write(blob);
      } catch (e) {
        // ファイル出力がキャンセルされた場合等は、ファイル保存せずreturnする
        return;
      } finally {
        if (stream !== null) {
          await stream.close();
        }
      }
    },

    /**
     * キャリブレーション結果表示文言取得
     * @param {string} type 文言の種別
     */
    // HACK: Phase4Step2-2終了間際にESLintのルールが変更になり、ロジックは変更出来なかったため回避。
    /* eslint-disable complexity */
    getCalibrationResultText(type) {
      let textId = undefined;

      switch (type.toLowerCase()) {
        case "00":
          textId = "individual.data_read_ws73_0x00";
          break;
        case "01":
          textId = "individual.data_read_ws73_0x01";
          break;
        case "11":
          textId = "individual.data_read_ws73_0x11";
          break;
        case "12":
          textId = "individual.data_read_ws73_0x12";
          break;
        case "13":
          textId = "individual.data_read_ws73_0x13";
          break;
        case "14":
          textId = "individual.data_read_ws73_0x14";
          break;
        case "21":
          textId = "individual.data_read_ws73_0x21";
          break;
        case "31":
          textId = "individual.data_read_ws73_0x31";
          break;
        case "41":
          textId = "individual.data_read_ws73_0x41";
          break;
        case "42":
          textId = "individual.data_read_ws73_0x42";
          break;
        case "43":
          textId = "individual.data_read_ws73_0x43";
          break;
        case "44":
          textId = "individual.data_read_ws73_0x44";
          break;
        case "45":
          textId = "individual.data_read_ws73_0x45";
          break;
        case "46":
          textId = "individual.data_read_ws73_0x46";
          break;
        case "47":
          textId = "individual.data_read_ws73_0x47";
          break;
        case "48":
          textId = "individual.data_read_ws73_0x48";
          break;
        case "49":
          textId = "individual.data_read_ws73_0x49";
          break;
        case "4a":
          textId = "individual.data_read_ws73_0x4a";
          break;
        case "4b":
          textId = "individual.data_read_ws73_0x4b";
          break;
        case "4c":
          textId = "individual.data_read_ws73_0x4c";
          break;
        case "4d":
          textId = "individual.data_read_ws73_0x4d";
          break;
        case "51":
          textId = "individual.data_read_ws73_0x51";
          break;
        case "52":
          textId = "individual.data_read_ws73_0x52";
          break;
        case "53":
          textId = "individual.data_read_ws73_0x53";
          break;
        case "61":
          textId = "individual.data_read_ws73_0x61";
          break;
        case "62":
          textId = "individual.data_read_ws73_0x62";
          break;
        case "63":
          textId = "individual.data_read_ws73_0x63";
          break;
        case "64":
          textId = "individual.data_read_ws73_0x64";
          break;
        case "65":
          textId = "individual.data_read_ws73_0x65";
          break;
        case "71":
          textId = "individual.data_read_ws73_0x71";
          break;
        default:
          break;
      }

      if (textId !== undefined) {
        return this.$t(textId);
      } else {
        return `0x${type.toUpperCase()}`;
      }
    },

    // ユーザ操作
    /** マスタデータチェックエラー画面 OK押下処理 */
    onInputFileErrorOkClicked() {
      this.closeWizard();
    },

    /** 正常終了画面 OK押下処理 */
    onSuccessOkClicked() {
      this.closeWizard();
    },

    /** 異常終了表示画面 保存押下処理 */
    onErrorFinishSaveClicked() {
      this.saveErrorCause();
    },

    /** 異常終了表示画面 戻る押下処理 */
    onErrorFinishBackClicked() {
      this.closeWizard();
    },

    /** キャリブレーション結果エラー表示画面 OK押下処理 */
    onResultErrorOkClicked() {
      this.closeWizard();
    },

    /** 完了処理エラー表示画面 OK押下処理 */
    onFinishProcessErrorOkClicked() {
      this.successProcess();
    },

    /** 通信エラー画面 OK押下処理 */
    async onCommunicationErrorOkClicked() {
      if (this.isSessionChanged) {
        await this.doTerminate();
      }
      this.closeWizard();
    },

    /** エラー画面 OK押下処理 */
    async onErrorOkClicked() {
      await this.doTerminate();
      this.closeWizard();
    },
  },

  async mounted() {
    this.init();
    this.openFilePicker(this.extension);
  }
};
